import * as React from "react";
import {
  Button,
  Avatar,
  Box,
  Typography,
  ListItemText,
  ListItem,
  List,
  LinearProgress,
  IconButton,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import ImageUploadButton from "../../components/button/ButtonWithIconAndText";
import useToast from "src/hooks/useToast";
import { useDispatch } from "src/redux/store";
import { aiTaskDisableAtom, batchEditorSelectedPresetAtom, fileCountAtom } from "../batchEditor/atoms";
import {useAtom} from "jotai";
import {
  addPendingFolderUploads,
  deleteFolder,
  endFolderProjectCreate,
  endFolderUpload,
  removePendingFolderUploads,
  reset,
  startFolderProjectCreate,
  startFolderUpload,
  addFailedFilesInFolderUpload,
  updateFolderProgress,
  updateShowDialog,
  updateStatus,
  updateFolders,
  removeFailedImageInFolders,
  resetFolderProgress,
  setFolderUploadStep,
  setBulkUplodAIType,
} from "src/redux/reducers/file-upload.reducer";
import { createFile, generateHash, getUploadProgress } from "src/utils/helpers";
import { useSelector } from "react-redux";
import { createProject, uploadFile } from "src/services/file-upload";
import { forOwn, get, head, isEmpty, toPlainObject, values } from "lodash";
import {
  removeUnReadNotification,
  updateUnReadNotification,
} from "src/redux/reducers/notification.reducer";
import {
  ERROR_MESSAGES,
  FILE_UPLOAD_FORMATS,
  FOLDER_SIZE_LIMIT,
  UPLOAD_STATUS,
} from "src/utils/constant";
import Resizer from "react-image-file-resizer";
import { completeStrapiData } from "src/strapiData";
import {STEPS} from "src/utils/constant";
import SelectPresetAndConfirm from './SelectPresetAndConfirm';
import {setJobId, setJobName} from "src/redux/reducers/jobs.reducer";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import { EventTrackName } from "@/modules/segment-event-tracking/constant";
import { segmentEventPayload } from "src/modules/editor-v2/Atoms";
import { useAtomValue } from "jotai";
import GlobalAPI from '@/modules/batchEditor/services/GlobalAPI';
import NewSuccessDialog from "./NewSuccessDialog";
import { EditorScreen } from "@/modules/batchEditor/BulkUploadEditor/constant";
import useAuth from '@/hooks/useAuth';
import { useRouter } from "next/router";
import { useDropzone } from "react-dropzone";
import BatchEditorSuccessDialog from "@/modules/file-upload/batchEditorSucessDialog";
import { BULK_AI_TYPE } from "@/utils/toolsConstants";
import SelectGenerationModel from "./SelectGenerationModel";


let fileQuantity=false;

export function convertToCSV(folderList) {
  let csvBody = '';
  const Height = 1500;
  const Width = 1500;
  const ProductPosition = 'Center Center';
  let maxImage = 0;

  sessionStorage.setItem('batchCSVData', JSON.stringify(folderList));
  
  folderList.forEach((folder,index) => {
    let currentCol = `${index},${folder.name},${Height},${Width},${ProductPosition},`;
    let currImageNo = 0;

    folder.imageUrls.forEach(image => {
      currentCol += `${image.dataURL},`;
      currImageNo++;
    });

    maxImage = Math.max(maxImage, currImageNo);
    currentCol += `\n`;
    csvBody += currentCol;
  });

  let csvHeader = 'SKU ID,Project Name,Height (px),Width (px),Product Position';
  for (let i = 1; i <= maxImage; i++) {
    csvHeader += `,Image ${i}`;
  }
  csvHeader += '\n';
  return csvHeader + csvBody;
}


const FolderUploadStep = (props) => {
  const { showFileUploadSuccess, setSuccessText, failedImagesHandler } = props;
  const Toast = useToast();
  const router = useRouter();
  const dispatch = useDispatch();
  const selectFileFun = React.useRef(null);
  // local state
  const [loading, isLoading] = React.useState(false);
  const uploadInputEl = React.useRef(null);
  const [csvInstructionFile, setCSVInstructionFile] = React.useState();
  const [csvInstructionError, setCSVInstructionError] = React.useState(null);
  // global state
  const filesData = useSelector((state) => state.fileUpload);
  const [fileCount, setFileCount] = useAtom(fileCountAtom);
  const {imageCompressionValue} = useSelector(state=>state.strapi);
  const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
  const batchEditorSelectedPreset = useAtomValue(batchEditorSelectedPresetAtom);
  const [folderData, setFolderData] = React.useState({});
  const [fileName, setFileName] = React.useState('');
  const [openSelectionDialog, setOpenSelectionDialog] = React.useState(false);
  const [removeBackground,setRemoveBackground] = React.useState(false);
  const {user} = useAuth();
  const [openFileUploadSuccessDialog, closeFileUploadSuccessDialog] = React.useState(false);
  const [totalFileCount, setTotalFileCount] = React.useState(0);
  const aiTaskDisable = useAtomValue(aiTaskDisableAtom);

  const onDrop = React.useCallback(
    (acceptedFiles) => {
      if (!acceptedFiles?.length) return;
      if (acceptedFiles.length !== 1) {
        setCSVInstructionError("Please upload exactly one CSV file");
      } else {
        setCSVInstructionFile(acceptedFiles[0]);
        setCSVInstructionError(null);
      }
    },
    [setCSVInstructionError]
  );
  
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "text/csv": [".csv"] },
  });
  
  const createProjectProgressTracker = (progressEvent, id) => {
    const progress = getUploadProgress(progressEvent);
    dispatch(updateFolderProgress({ id: id, progress: progress }));
  };

  const HandleRawOrOriginal = () => {
      setFileCount(totalFileCount);
      closeFileUploadSuccessDialog(true);
  };

  const selectionOptionHandler = (value) => {
    setRemoveBackground(value);
    setOpenSelectionDialog(true);
  };

  const saveProject = async (selectionData) => {
    if(user?.user?.infoGraphicsUser ){
      isLoading(true);
      const csvData = convertToCSV(folderData);
      // Create a Blob object from the CSV data
      const blob = new Blob([csvData], { type: 'text/csv' });

      const formData = new FormData();
      formData.append("file", blob,fileName);
      formData.append("uploadType", "csv");
      csvInstructionFile && formData.append("instructionFile", csvInstructionFile);
      formData.append("removeBackground",removeBackground);
      formData.append("marketplaceId",batchEditorSelectedPreset?.marketplace_id);
      filesData.bulkUplodAIType && formData.append("batchType",filesData.bulkUplodAIType);
      selectionData?.modelSelection && formData.append("modelSelection",JSON.stringify(selectionData?.modelSelection));
      await GlobalAPI.uploadBulkJobCSV(formData)
        .then(response => {
          if(response.data?.data?.batchId){
          dispatch(setFolderUploadStep(STEPS.FOLDER_UPLOAD_STEP_3));
          let mode = EditorScreen.MAIN;
          if (aiTaskDisable) {
            mode = EditorScreen.PRODUCT_LIFESTYLE;
            router.replace({
              query: { mode, batchAI: response.data?.data?.batchId},
            });
          } else {
            router.push(`/dashboard/batch-editor?mode=${EditorScreen.GENERATE}&batchAI=${response.data?.data?.batchId}`);
          }
          dispatch(setBulkUplodAIType(''));
        }else{
          Toast.error("Something went wrong")
        }
        })
        .catch(error=>{
          const message = error.response.data.message?.csvError || error.response.data?.errorResponse || 'CSV upload failed'
          Toast.error(message)
        })
      await new Promise((resolve)=>setTimeout(resolve),3000);
      onCloseHandler();
      isLoading(false);
      return;
    };

    isLoading(true);

    const folderCount = values(filesData?.folders).length;
    values(filesData?.folders).forEach(async (folder, idx) => {
      try {
        const payload = {
          name: folder?.name,
          imageURLs: folder?.files,
        };
        dispatch(startFolderProjectCreate({ id: folder?.id }));
        dispatch(updateStatus(UPLOAD_STATUS?.PROJECT_CREATE_IN_PROGRESS));
        const options = {
          onUploadProgress: (progressEvent) => {
            createProjectProgressTracker(progressEvent, folder?.id);
          },
        };
        const response = await createProject(payload, options);
        if (get(response, "data.success", false)) {
          dispatch(endFolderProjectCreate({ id: folder?.id }));
          if (idx === Object.values(filesData.folders).length - 1) {
            setSuccessText(`${folderCount} Projects`);
            isLoading(false);
            showFileUploadSuccess();
            dispatch(updateShowDialog(false));
            dispatch(reset());
            dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_IN_DONE));
            dispatch(removeUnReadNotification(folder?.id));
            dispatch(setJobId(response?.data?.data?.jobId));
            dispatch(setJobName(folder?.name))
            TrackWebappEvent(`${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._click_upload_image_batch_edit}`,{
              ...getSegmentPayloadAtom,
              imageUrl:folder?.files || "",
              job_id:response?.data?.data?.jobId || "",
              job_name:folder?.name || ""
              });
          }
        } else {
          isLoading(false);
          dispatch(updateStatus(UPLOAD_STATUS.PROJECT_CREATE_FAILED));
          dispatch(endFolderProjectCreate({ id: folder?.id }));
        }
      } catch (error) {
        const message = get(error, "response.data.message", ERROR_MESSAGES.SOME_THING_WENT_WRONG);
        Toast.error(message);
        isLoading(false);
        dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOAD_DONE));
        dispatch(endFolderProjectCreate({ id: folder?.id }));
      }
    });
  };
  
  const onCloseHandler=()=>{
    dispatch(reset());
    dispatch(updateShowDialog(false));
  }

  const getFolderSize = (files, sizeFormat) => {
    if (isEmpty(files)) return 0;
    let size = 0;
    if (sizeFormat === "mb") {
      forOwn(files, (file) => {
        size += file.size / 1000000;
      });
    }
    return Math.round(size, 0);
  };

  const checkFileFormat = (files) => {
    let unSupportedFiles = [];
    forOwn(files, (file) => {
      if (
        get(file, "type", null) &&
        !FILE_UPLOAD_FORMATS.includes(get(file, "type", ""))
      ) {
        unSupportedFiles.push(get(file, "type", ""));
      }
    });
    return unSupportedFiles.length > 0;
  };

  const handleFileUploadFailCase = (file, name, id) => {
    dispatch(
      addFailedFilesInFolderUpload({
        id: id,
        name: name,
      })
    );
    failedImagesHandler.add({
      id: generateHash(file.name),
      folder_id: id,
      file: file,
      name: name,
      type: "folder",
    });
  };

  const getFileS3Url = async (file, name, id, options) => {
    try {
      const response = await uploadFile(file, options);
      if (get(response, "data.success", false)) {
        const imageUrl = head(get(response, "data.images", []));
        return imageUrl;
      } else {
        handleFileUploadFailCase(file, name, id);
      }
      return false;
    } catch (error) {
      handleFileUploadFailCase(file, name, id);
      console.error(error);
    }
  };

  const retryImageUpload = async (folderId) => {
    try {
      const failedImages = failedImagesHandler.searcByFolderId(folderId);
      const progress = Math.round(100 / failedImages.length, 0);
      dispatch(resetFolderProgress({ id: folderId }));
      const promiseList = failedImages.map(async (failedImage) => {
        const response = await getFileS3Url(failedImage?.file);
        failedImagesHandler.remove(generateHash(failedImage?.file?.name));
        dispatch(updateFolderProgress({ id: folderId, progress: progress }));
        return response;
      });
      const imageUrls = await Promise.all(promiseList);
      dispatch(updateFolders({ id: folderId, files: imageUrls, load: false }));
      dispatch(removeFailedImageInFolders({ id: folderId }));
      dispatch(
        updateUnReadNotification({
          id: folderId,
          progress: 101,
          error: false,
          createdAt: new Date(),
        })
      );
    } catch (error) {}
  };

  const onFolderSelect = async (e) => {
    try {
      let filesSelected = e?.target?.files;
      if(filesSelected.length > 50)
      {
        Toast.error("Select only upto 50 images")
        return;
      }
      if (!filesSelected.length) {
        Toast.error(ERROR_MESSAGES.FOLDER_IS_EMPTY);
        return;
      }
      let files = [];
      setFileCount(filesSelected.length)
      let progressBuffer = Math.round(100 / filesSelected.length, 2);
      let updatedProgress = progressBuffer;
      let name = head(
        get(head(filesSelected), "webkitRelativePath", "").split("/")
      );
      let id = generateHash(name);
      let folderSize = getFolderSize(filesSelected, "mb");
      let folderHasSupportedFiles = checkFileFormat(filesSelected);

      // validation for folder size limit
      // if (folderSize > FOLDER_SIZE_LIMIT) {
      //   Toast.error(ERROR_MESSAGES.FOLDER_SIZE_LIMIT_EXCEEDED);
      //   return;
      // }

      // validations for supported files inside a folder selected
      if (folderHasSupportedFiles) {
        Toast.error(ERROR_MESSAGES.FILE_FORMAT_NOT_SUPPORTED);
        return;
      }

      dispatch(
        startFolderUpload({
          id: id,
          name: name,
          progress: progressBuffer,
        })
      );
      dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOADING));
      dispatch(addPendingFolderUploads(id));
      for (let file in filesSelected) {
        if (filesSelected.hasOwnProperty(file)) {
          const filesCompressed= await imageCompressor(filesSelected[file]);
          const url = await getFileS3Url(filesCompressed || filesSelected[file], name, id);
          updatedProgress += progressBuffer;
          dispatch(updateFolderProgress({ id, progress: progressBuffer }));
          dispatch(
            updateUnReadNotification({
              id: id,
              progress: updatedProgress,
              createdAt: new Date(),
            })
          );
          // validation to prevent null values to be pushed in files list
          if (url) {
            files.push(url);
          }
        }
      }
      dispatch(
        endFolderUpload({
          id: generateHash(name),
          name: name,
          files: files,
        })
      );
      if (files?.length < filesSelected?.length) {
        dispatch(
          updateUnReadNotification({
            id: generateHash(name),
            progress: 101,
            createdAt: new Date(),
            errorDescription: "Folder upload failed",
            error: true,
          })
        );
      }
      dispatch(removePendingFolderUploads(id));
      if (filesData?.pendingFolderUploads?.length === 0) {
        isLoading(false);
        dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOAD_DONE));
      }
      clearInputElValue();
    } catch (error) {
      clearInputElValue();
      console.error(error);
    }
  };
  const onFolderSelectBulkUpload = async (e) => {
    try {
      let filesSelected = e?.target?.files;
      let subfolderPath = '';
      for (let file in filesSelected) {
        if (filesSelected.hasOwnProperty(file)) {
          subfolderPath = filesSelected[file].webkitRelativePath.split('/');
          setFileName(subfolderPath[0]);
        }
      }
      if (!filesSelected.length) {
        Toast.error(ERROR_MESSAGES.FOLDER_IS_EMPTY);
        return;
      }
      let folderSize = getFolderSize(filesSelected, "mb");
      let folderHasSupportedFiles = checkFileFormat(filesSelected);
  
      if (folderHasSupportedFiles) {
        Toast.error(ERROR_MESSAGES.FILE_FORMAT_NOT_SUPPORTED);
        return;
      }
  
      const folderMap = {};
      const folderListMap = {};
  
      dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOADING));
      let totalFile = 0;
      for (let file in filesSelected) {
        if (filesSelected.hasOwnProperty(file)) {
          const subfolderPath = filesSelected[file].webkitRelativePath.split('/');
          if (subfolderPath.length > 2) {
            const subfolderName = subfolderPath[1];
            if (!folderListMap[subfolderName]) {
              folderListMap[subfolderName] = [];
            }
            folderListMap[subfolderName].push(filesSelected[file]);
          }
        }
      }
  
      for (const item in folderListMap) {
        const folderName = item;
        const subId = generateHash(folderName);
        let progressBuffer = Math.round(100 / folderListMap[item].length, 2);
        let updatedProgress = progressBuffer;
  
        dispatch(startFolderUpload({
          id: subId,
          name: folderName,
          progress: progressBuffer,
        }));
  
        dispatch(addPendingFolderUploads(subId));
  
        if (!folderMap[folderName]) {
          folderMap[folderName] = [];
        }
  
        for (let i = 0; i < folderListMap[item].length; i++) {
          const filesCompressed = await imageCompressor(folderListMap[item][i]);
          const url = await getFileS3Url(filesCompressed || folderListMap[item][i], folderName, subId);
          totalFile++;
          if (url) {
            const imageData = {
              dataURL: url
            };
            folderMap[folderName].push(imageData);
          }
          updatedProgress += progressBuffer;
          dispatch(updateFolderProgress({ id: subId, progress: updatedProgress }));
        }
  
        dispatch(endFolderUpload({
          id: subId,
          name: folderName,
          files: folderMap[folderName],
        }));
  
        dispatch(updateUnReadNotification({
          id: subId,
          progress: updatedProgress,
          createdAt: new Date(),
        }));
  
        dispatch(removePendingFolderUploads(subId));
  
        if (folderMap[folderName].length < folderListMap[item].length) {
          dispatch(updateUnReadNotification({
            id: generateHash(folderName),
            progress: 101,
            createdAt: new Date(),
            errorDescription: "Folder upload failed",
            error: true,
          }));
        }
  
        setFolderData(prev => {
          const prevFolderData = Array.isArray(prev) ? prev : [];
          const filteredList = prevFolderData.filter(e => e.name !== item);
          return [...filteredList, { name: item, imageUrls: folderMap[item] }];
        });
      }
      setTotalFileCount(totalFile);
      if (filesData?.pendingFolderUploads?.length === 0) {
        isLoading(false);
        dispatch(updateStatus(UPLOAD_STATUS.FOLDER_UPLOAD_DONE));
      }
      clearInputElValue();
    } catch (error) {
      clearInputElValue();
      console.error(error);
    }
  };

  
  const clearInputElValue = () => {
    if (!uploadInputEl.current) return;
    uploadInputEl.current.value = null;
  };

  const removeFolder = (id) => {
    dispatch(deleteFolder(id));
    dispatch(removeUnReadNotification(id));
    dispatch(removePendingFolderUploads(id));
  };

  const imageCompressor=(files)=>{
    return new Promise((res,rej)=> {
      let extention=files?.type?.split('/')[1];
      const filename=files?.name;
      let resize= null;
      const bulkImageUploadSize = imageCompressionValue?.bulkImageUploadSize ? imageCompressionValue?.bulkImageUploadSize : 6000000;
      const imageCompressionFactor = imageCompressionValue?.imageCompressionFactor ? imageCompressionValue?.imageCompressionFactor : 80;
      if(files?.size >= bulkImageUploadSize) resize = imageCompressionFactor >= 80 ? imageCompressionFactor : 80 ;
      if(!resize) res(null);
      let w;
      let h;
      var url = URL.createObjectURL(files);
      var img = document.createElement('img');
      img.src = url;
      img.onload = function(){
          w = img.width;
          h = img.height;
      }
      try {
        Resizer.imageFileResizer(
          files,
          w,
          h,
          extention,
          resize,
          0,
          (uri) => {
            fetch(uri)
              .then(res => res.blob())
               .then(blob => {
                      const fd = new FormData();
                      const file = new File([blob], filename);
                      fd.append('image', file);
                     res(file);
               });
          },
        );
      } catch (err) {
        console.error(err);
        rej(err)
      }
    })
    
  };

  const debounceEffect = (delay)=>{
    if(selectFileFun.current)
    clearTimeout(selectFileFun.current);

    selectFileFun.current = setTimeout(()=>{
      uploadInputEl.current?.click();
    },delay);
  };


  React.useEffect(() => {
    if (uploadInputEl && !Object.keys(filesData.files).length) {
      debounceEffect(600);
    }
  }, []);

  const {entireStrapiData} = useSelector((state)=> state.strapi)
  const createProjectData = entireStrapiData?.StudioBatchEditorText?.StudioBatchEditorText;
  const defaultStrapiData = completeStrapiData?.CreateProjectWebApp?.CreateProjectWebApp;


  return (
    <>
    {filesData.folderUploadStep === STEPS.FOLDER_UPLOAD_STEP_2 &&
    <Box p="16px">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        position="relative"
        sx={{
          border: "0.5px dashed rgba(38, 38, 38, 0.4)",
          borderRadius: "4px",
        }}
      >
        <ImageUploadButton  captionText={ createProjectData?.ImportFolderText || defaultStrapiData?.ImportFolders3Text }
        iconImageUrl={createProjectData?.FolderIcon || defaultStrapiData?.FolderIcon} 
        underline />
        <input
          webkitdirectory="true"
          ref={uploadInputEl}
          directory="true"
          multiple={true}
          disabled={
            filesData.status === UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS
          }
          style={{
            opacity: 0,
            width: "100%",
            height: "100",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1,
            cursor: "pointer",
          }}
          type="file"
          accept="image/jpeg,
            image/bmp,
            image/JFIF,
            image/jpg,
            image/cr2,
            image/png,
            image/JPEG,
            image/JPG,
            image/PNG,
            image/PSD,
            image/TIFF,
            image/NEF,
            image/RAF,
            image/CR2,
            image/DNG,
            image/ARW,
            image/CRD,
            image/webp,
            image/gif"
          onChange={user?.user?.infoGraphicsUser ? onFolderSelectBulkUpload : onFolderSelect}
        />
        {Object.values(filesData.folders).length > 0? fileQuantity= true: fileQuantity=false }
      </Box>
      {user?.user?.infoGraphicsUser && filesData.bulkUplodAIType !== BULK_AI_TYPE.BULK_UPLOAD_FACE_SWAP &&
      <div {...getRootProps()} style={containerStyle.dropzoneInstructionStyles}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Add Instruction CSV file here ...</p>
          ) : (
            <p>
              {csvInstructionFile?.name ||
                `Drop Instruction CSV file here`}
            </p>
          )}
          {csvInstructionError && <h3 style={containerStyle.errorMsg}>{csvInstructionError}</h3>}
      </div>}
      <Box mt={2}  sx={{maxHeight:'400px',overflow:'auto'}}>
        <List>
          {filesData &&
            Object.values(filesData.folders).length > 0 &&
            Object.values(filesData.folders).map((folder) => {
              return (
                <Box key={folder?.id} mb={2}>
                  <ListItem
                    disabled={folder?.load}
                    secondaryAction={
                      <Box display="flex">
                        {filesData.failedImagesInFolders[folder?.id] &&
                          filesData.status !== UPLOAD_STATUS.FILE_UPLOADING && (
                            <RefreshIcon
                              onClick={() => retryImageUpload(folder?.id)}
                              sx={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                                cursor: "pointer",
                              }}
                            />
                          )}
                        <Typography
                          variant="caption"
                          component="div"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          {folder?.files?.length} {entireStrapiData?.StaticScreen?.CreateProjectWebApp?.ImagesText || completeStrapiData?.StaticScreen?.CreateProjectWebApp?.ImagesText}
                          <Avatar
                            src="/icons/upload.svg"
                            sx={{
                              width: "16px",
                              height: "16px",
                              marginLeft: "4px",
                            }}
                          />
                        </Typography>
                      </Box>
                    }
                    sx={{
                      backgroundColor: "#F9F9F9",
                      padding: "24px",
                      borderRadius: "4px",
                      border: "1px solid #EEEEEE",
                    }}
                  >
                      <Avatar
                        variant="square"
                        sx={{
                          width: "24px",
                          height: "24px",
                          marginRight: "16px",
                        }}
                        src="/icons/folder-upload-icon.svg"
                        alt="folder upload icon"
                      />
                    <ListItemText>
                      <Typography variant="caption">{folder.name}</Typography>
                    </ListItemText>
                    <IconButton
                      disabled={
                        folder?.load ||
                        filesData.status ===
                          UPLOAD_STATUS.PROJECT_CREATE_IN_PROGRESS
                      }
                      aria-label="close"
                      onClick={() => removeFolder(folder?.id)}
                      sx={{
                        padding: 0,
                        position: "absolute",
                        right: 8,
                        top: 4,
                        color: (theme) => theme.palette.dark,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </ListItem>
                  {folder?.load ? (
                    <LinearProgress
                      variant="buffer"
                      color="secondary"
                      value={folder.progress}
                      valueBuffer={folder.valueBuffer}
                    />
                  ) : null}
                  {!folder?.load &&
                    filesData?.failedImagesInFolders[folder.id] && (
                      <Typography variant="caption" color="error">
                        {createProjectData?.FolderUploadFailedText || defaultStrapiData?.FolderUploadFailedText}
                      </Typography>
                    )}
                  {folder?.uploading ? (
                    <LinearProgress
                      variant="buffer"
                      color="primary"
                      value={folder.progress}
                      valueBuffer={folder.valueBuffer}
                    />
                  ) : null}
                </Box>
              );
            })}
        </List>
        
        {fileQuantity==false? createProjectData?.FolderUploadNote || defaultStrapiData?.NotePleaseUploadText :" "}
      </Box>
      <Box mt={1}>
        <Button
          variant="contained"
          color="secondary"
          disabled={
            loading || filesData.status !== UPLOAD_STATUS.FOLDER_UPLOAD_DONE
          }
          fullWidth
          onClick={user?.user?.infoGraphicsUser ? HandleRawOrOriginal : saveProject}
        >
          {createProjectData?.ContinueCTA || `Continue`}
        </Button>
      </Box>
    </Box>}
    {filesData.folderUploadStep === STEPS?.FOLDER_UPLOAD_STEP_3 && (
    user?.user?.infoGraphicsUser ? <NewSuccessDialog 
        open={true}
        disableBtn={false}
        disableCredit={true}
        onClose={onCloseHandler}
        successText={`Successful`}
        message={`After your projects have been Created, You can track the progress of your order on the 'My Projects' tab.`}/>
        : 
  <SelectPresetAndConfirm showFileUploadSuccess={showFileUploadSuccess} setSuccessText={setSuccessText} />)}
  <BatchEditorSuccessDialog 
      open={openFileUploadSuccessDialog}
      onClose={()=>closeFileUploadSuccessDialog(false)}
      saveProject={selectionOptionHandler}
  />
  <SelectGenerationModel
      open={openSelectionDialog}
      onClose={()=>setOpenSelectionDialog(false)}
      saveProject={saveProject}
       />
    </>
  );
};

const containerStyle = {
  dropzoneInstructionStyles: {
    border: "2px dashed #EEEEEE",
    borderRadius: "4px",
    padding: "10px",
    textAlign: "center",
    cursor: "pointer",
    margin: "10px",
    opacity:0.8
  },
  errorMsg: {
    color: 'red',
    fontSize: '12px',
  },
};

export default FolderUploadStep;
